import { Divider, Flex, Text } from "@chakra-ui/react";
import { PaymentCard } from "@components/card";
import styled from "@emotion/styled";
import { usePaymentRoomState } from "@shared/client";
import { MEDIA } from "@styles/common";
import theme from "@styles/theme";
import { useEffect } from "react";
import { SelectListProps } from "./selectedRooms.type";

export const SelectedRooms = ({ data }: SelectListProps) => {
    const [paidRoomValue, setPaidRoomValue] = usePaymentRoomState();

    const roomPrice = paidRoomValue.reduce((acc, it) => acc + it.discountPrice, 0);
    const addPrice = paidRoomValue.reduce((acc, it) => acc + it.finalPrice, 0) - roomPrice;
    const couponPrice = paidRoomValue.reduce((acc, it) => acc + it.couponDiscount, 0);
    const totalPrice =
        paidRoomValue.reduce((acc, item) => acc + item.finalPrice, 0) -
        paidRoomValue.reduce((acc, item) => acc + item.couponDiscount, 0);

    const { isMobile } = MEDIA();

    useEffect(() => {
        setPaidRoomValue(
            data.map((it) => ({
                ...it.paidRooms,
                couponDiscount: 0, // 초기값 추가
                couponName: null,
                coupon_idx: null,
            })),
        );
    }, [data]);

    return (
        <Flex width="100%" flexDir="column" gap="16px">
            <Flex width="100%" flexDir="column" gap="24px">
                {paidRoomValue.length > 0 &&
                    paidRoomValue.map((it) => {
                        return (
                            <>
                                <PaymentCard key={it.roomIdx} {...it} />
                                <CustomDivider />
                            </>
                        );
                    })}
            </Flex>
            {totalPrice && (
                <Flex w="100%" justifyContent={isMobile ? "flex-start" : "flex-end"}>
                    <Flex alignItems="flex-end" width={"100%"} flexDir="column" gap="12px">
                        <Flex w="100%" flexDir="column" gap="4px">
                            <Flex w="100%" justifyContent="space-between">
                                <Text>객실 금액</Text>
                                <Flex alignItems="center" gap="4px">
                                    <Text fontSize="16px">{roomPrice.toLocaleString()}</Text>
                                    <Text>원</Text>
                                </Flex>
                            </Flex>
                            {addPrice > 0 && (
                                <Flex w="100%" justifyContent="space-between">
                                    <Text>인원 추가 금액</Text>
                                    <Flex alignItems="center" gap="4px">
                                        <Text fontSize="16px">{addPrice.toLocaleString()}</Text>
                                        <Text>원</Text>
                                    </Flex>
                                </Flex>
                            )}
                            {couponPrice > 0 && (
                                <Flex w="100%" justifyContent="space-between">
                                    <Text>쿠폰 할인</Text>
                                    <Flex alignItems="center" gap="4px">
                                        <Text color="red">- {couponPrice.toLocaleString()}</Text>
                                        <Text>원</Text>
                                    </Flex>
                                </Flex>
                            )}
                        </Flex>
                        <Flex w="100%" justifyContent="space-between">
                            <Text fontSize="20px" fontWeight="700">
                                총 결제 금액
                            </Text>
                            <Flex alignItems="center" gap="4px">
                                <Text fontSize="24px" color={theme.COLOR.pink[200]} fontWeight="500">
                                    {totalPrice.toLocaleString()}
                                </Text>
                                <Text>원</Text>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            )}
        </Flex>
    );
};

const CustomDivider = styled(Divider)`
    color: ${({ theme }) => theme.COLOR.gray[300]};
`;
